import React, { useState } from "react";
import Banner from "../../components/banner/Banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet-async";

function FaqPage(props: { isConnect: boolean }) {

  const AnswerQuestionList = [
    {

      question: "Est-ce que je peux être voyageur et résident ?",
      answer: `Oui :
      Avec le forfait BASIC, en créant deux comptes distincts, chacun avec son propre abonnement BASIC. 
      Dans un avenir proche, ce sera également possible avec un seul compte et un seul abonnement, grâce à un forfait différent en cours de développement.`
    },
    {
      question: "Quels sont les badges visibles sur les profils Cemade ?",
      answer: `Il existe  4 badges communautaires pour renforcer la confiance entre les membres :    
    
      🌱Initiator : Détenu par ceux qui ont lancé le projet: de l'idée en passant par le développement puis la mise en production et la maintenance.
    
    🏴 Ambassador : Il distingue les membres qui contribuent activement à faire connaître Cemade sur le terrain et participent activement à son lancement: attribué soit après une rencontre avec l'équipe, 
      soit après avoir indiqués 30 trocs comme étant éffectué par les deux parties.
      Spécificité : les Ambassadeurs peuvent eux-mêmes attribuer le badge "Confiance partagée" à d’autres utilisateurs qu’ils rencontrent.
    
    🌟 Pionnier : Il distingue les 1000 premiers membres qui croient en la vision de Cemade: attribué automatiquement.
    
    🤝 Confiance partagée : Il indique que de la confiance s'est partagée entre vous et un membre pionnier: attribué par un membre pionnier à un membre rencontré.
    
    ⚡ Actif/Active : Il reflète votre implication concrète dans les échanges: attribué automatiquement à toute personne ayant initié au moins 2 demandes ou ayant liké au moins 2 de troc.
    
    🛡️ Fiable : Il indique que vous avez mené des échanges jusqu'a leur terme: attribué automatiquement dès que vous marqué 3 trocs comme éffectués.
    
    💡 Les badges n’ont pas de hiérarchies, mais chacun reflète une forme de participation ou de reconnaissance, utile pour mieux se repérer entre utilisateurs.`
    }
    ,
    {
      question: "A quoi sert de renseigner ma région ?",
      answer: "Le résident renseigne sa région pour permettre au voyageur de connaître les trocs disponibles autour de lui."
    },
    {
      question: "Puis-je faire plusieurs demandes de trocs ?",
      answer: `Pour le voyageur: tu pourras effectuer une demande de troc à la fois avec ton élément de troc. 
      Si tu l'annules avant acceptation ou que le résident la refuse, tu pourras en refaire une autre et ainsi de suite...`
    },
    {
      question: "Puis-je accepter plusieurs propositions de trocs ?",
      answer: "Pour le résident: tant que les éléments de trocs sont disponibles, je peux accepter les propositions."
    },
    {
      question: "Combien d'éléments à échanger puis-je créer ?",
      answer: `En forfait BASIC : durant la durée de mon abonnement, je peux créer 1 seul élément à échanger.
       En forfait PREMIUM : durant la durée de mon abonnement, je peux créer jusqu'à 8 éléments à échanger.`
    },
    {
      question: "Combien de temps dure mon abonnement ?",
      answer: "Mon abonnement dure 30 jours."
    },
    {
      question: "Mon abonnement est-il renouvelable ?",
      answer: "Oui, automatiquement."
    },
    {
      question: "A quoi ça sert que le résident like un élément d'échange du voyageur ?",
      answer: "Cela sert à montrer mon intérêt et à indiquer au voyageur que son élément d'échange m'intéresse et qu'il peut me faire une demande de troc."
    },
    {
      question: "Puis-je modifier mon élément d'échange ?",
      answer: "Oui, tant qu'il est disponible, c'est à dire qu'il n'a pas fait l'objet d'une demande ou d'une proposition acceptée."
    },
    {
      question: "Le voyageur peut-il annuler une demande de trocs ?",
      answer: "Oui, tant que la demande n'a pas été acceptée par le résident."
    },
    {
      question: "Le résident peut-il refuser une proposition de trocs ?",
      answer: "Oui, tant qu'elle n'a pas été acceptée."
    },
    {
      question: "Quand est-ce que je peux discuter avec mon partenaire de troc ?",
      answer: "Une fois que la demande ou que la proposition de troc a été acceptée par le résident. Un tchat sera disponible pour organiser et finaliser le troc."
    },
    {
      question: "Combien de temps reste ouvert le tchat de discussion ?",
      answer: "Le tchat reste ouvert le temps du troc."
    },
    {
      question: "Comment rechercher un partenaire de troc ?",
      answer: "Il suffit d'autoriser la localisation GPS."
    },
    {
      question: "Quel est mon abonnement à mon inscription ?",
      answer: "A l'inscription, j'ai un abonnement BASIC."
    },
    {
      question: "Quand je créé un élément d'échange, combien de services et de besoins puis-je ajouter ?",
      answer: "Je peux ajouter 3 services et 3 besoins maximum."
    }
  ]

  const [indexSelected, setIsIndexSelected] = useState<number>(-1)

  const clickAnswer = (index: number) => {
    // Si la question cliquée est déjà ouverte, on la ferme, sinon on l'ouvre
    if (index === indexSelected) {
      setIsIndexSelected(-1); // Fermer la réponse si la même question est cliquée
    } else {
      setIsIndexSelected(index); // Ouvrir la réponse correspondante à l'index
    }
  }

  // Fonction pour convertir les retours à la ligne
  const formatAnswer = (answer: string) => {
    return answer.split('\n').map((line, index) => {
      return (
        <p key={index} className="text-start font-bold text-greenCustom p-1 w-full">
          {line}
        </p>
      );
    });
  };

  return (
    <>
      {/* === Helmet for SEO === */}
      <Helmet>
        <title>FAQ - Cemade</title>
        <meta
          name="description"
          content="Toutes les réponses à vos questions concernant Cemade, que vous soyez voyageur, nomade ou résident. Découvrez comment utiliser Cemade."
        />
        <meta property="og:title" content="FAQ - Cemade" />
        <meta property="og:description" content="Vous avez des questions sur Cemade ? Retrouvez toutes les réponses dans notre FAQ pour comprendre comment échanger des services entre voyageurs et résidents." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cemade.fr/faq" />
        <meta property="og:image" content="https://cemade.fr/logo-cemade.png" />
        <meta property="og:image:alt" content="Logo de Cemade - plateforme d’échange de services" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Banner isConnect={props.isConnect} showBtnHome={true} />

      <section className="inline-block p-3">
        <h1 className="font-semibold text-lg lg:text-4xl p-4 inline-block">Foire aux questions</h1>

        <ul>
          {AnswerQuestionList.map((item, index) => (
            <React.Fragment key={index}>
              <div onClick={() => { clickAnswer(index) }} className="cursor-pointer border border-black p-4 hover:bg-gray-200 transition-colors rounded-2xl max-w-[606px]">
                <div className="flex justify-between">
                  <li className="flex justify-start font-semibold ">{item.question}</li>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
                {index === indexSelected && <p className="text-start font-bold text-greenCustom p-4 w-full" >{formatAnswer(item.answer)}</p>}
              </div>
              <br />
            </React.Fragment>
          ))}
        </ul>
      </section>
    </>
  )
}
export default FaqPage;